module.exports = __webpack_public_path__ + "static/noelle-banner-20b1e94e4dcf689c00954c85cd835804.png";